import styled from 'styled-components';
export const LoaderWrapper = styled.div `
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Subtitle = styled.div `
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 24px;

  p + p {
    margin-top: 12px;
  }
`;
